export default function notificacao(type, message, time) {
  const boxNotification = document.querySelector('.box-notificacoes');

  setTimeout(() => {
    const div = document.createElement('div');
    div.classList.add(`notificacao-${type}`, 'ativo');

    let finalText = '';

    if (typeof message === 'string') {
      try {
        const json = JSON.parse(message);
        finalText = formatMessage(json);
      } catch {
        finalText = message;
      }
    } else if (typeof message === 'object') {
      finalText = formatMessage(message);
    } else {
      finalText = String(message);
    }

    div.innerHTML = `<h3 class="notificacao-text-color" style="white-space: pre-line;">${finalText}</h3>`;
    boxNotification.appendChild(div);

    div.addEventListener('click', removeNotificacao);

    setTimeout(removeNotificacao, time || 6300);

    function removeNotificacao() {
      div.remove();
    }

    function formatMessage(obj) {
      let lines = [];
      for (const chave in obj) {
        if (Array.isArray(obj[chave])) {
          lines.push(`${obj[chave].join('\n')}`);
        } else if (typeof obj[chave] === 'string') {
          lines.push(obj[chave]);
        }
      }
      return lines.join('\n');
    }
  }, 1000);
}
